import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, DoCheck } from '@angular/core'
import { EnrollmentElectionType } from '../../models/enrollment-election-type'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { EnrollmentDataService } from '../../gateways/enrollment-data-service'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { ElectionPeriods } from '../../models/election-periods'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'
import { ElectionModel } from '../../models/election-model'
import * as moment from 'moment'
@Component({
    selector: 'ElectionPeriod',
    templateUrl: 'election.period.component.html'
})
export class ElectionPeriodComponent implements OnInit, AfterViewInit, DoCheck {
    @Output() reasonCodeChanged: EventEmitter<any> = new EventEmitter<any>()
    @Output() hasDateField: EventEmitter<boolean> = new EventEmitter<boolean>()
    @Output() periodSelectdChanged: EventEmitter<string> = new EventEmitter<string>()
    @Output() sepDateChange: EventEmitter<string> = new EventEmitter<string>()
    @Output() AEPVisible: EventEmitter<boolean> = new EventEmitter<boolean>()
    enrollmentElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    @Input() reasonCode = '-1'
    @Input() periodSelected = ''
    @Input() disabled: boolean = false

    selectedElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    electionOprionsByPeriod: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    electionPeriods: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData

    selectedOption = 'None'
    electedOptionCode = '0'
    onDate: string = '' // new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    sepDate: Date | null
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    isDateField = false
    EnrollmentViewModel: EnrollmentViewModel
    icName: string
    public currentUser: CurrentUser = {} as CurrentUser
    SEPDatePositionDown: boolean = false
    reportFlag: boolean = false

    constructor(
        private selElectionPeriod: EnrollmentDataService,
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private _currentUserGateway: CurrentUserGateway
    ) {}

    ngDoCheck() {
        if (
            this.EnrollmentViewModel.APPDT &&
            this.EnrollmentViewModel.OldAppDT &&
            this.EnrollmentViewModel.APPDT != null &&
            this.EnrollmentViewModel.APPDT.toDateString() != this.EnrollmentViewModel.OldAppDT.toDateString()
        ) {
            this.SetPageData()
            this.EnrollmentViewModel.OldAppDT = this.EnrollmentViewModel.APPDT
        }
    }
    ngOnInit() {
        if (this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.SetPageData()
                }
            })
        } else {
            this.SetPageData()
        }

        this.icName = this.currentUser.insuranceCompanyName

        var User = localStorage.getItem('UserSessionContext')
        this.currentUser = JSON.parse(User!)
        if (this.currentUser !== null && this.currentUser !== undefined && this.currentUser.insuranceCompanyName !== undefined) {
            this.icName = this.currentUser.insuranceCompanyName
            if (this.icName === this._global.insuranceCompanyNameNEJE) {
                this.SEPDatePositionDown = true
            } else {
                this.SEPDatePositionDown = false
            }
        }
    }

    private SetPageData() {
        let insuranceCoId = this._global.currentUser.insuranceCompanyId
        let planYear: string = String(this._global.selectedPlanYear)

        this.EnrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()

        if (planYear === '0') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)
                this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                planYear = String(this._global.selectedPlanYear)
                this.EnrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME

                this.EnrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                this.EnrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                this.EnrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                this.EnrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                this.EnrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                this.EnrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                this.EnrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME

                this._enrollementGateway.setEnrollmentViewModel(this.EnrollmentViewModel)
            }
        }

        //this._enrollementGateway.getElectionPeriodInfo(planYear)
        //    .subscribe()

        let isDataEntryOrExternal: number
        isDataEntryOrExternal = 0
        //1-External,ExternalSMS, SINGLEGROUP , 2- Data Entry, 0- Rest of the Enrollment Forms
        if (
            this.EnrollmentViewModel !== undefined &&
            this.EnrollmentViewModel.FORMNAME !== undefined &&
            (this.EnrollmentViewModel.FORMNAME === 'EXTERNAL' ||
                this.EnrollmentViewModel.FORMNAME === 'EXTERNALSMS' ||
                this.EnrollmentViewModel.FORMNAME === 'DATAENTRY' ||
                this.EnrollmentViewModel.FORMNAME === 'SINGLEGROUP' ||
                this.EnrollmentViewModel.FORMNAME === 'NEJEPHONE')
        ) {
            if (this.EnrollmentViewModel.FORMNAME === 'DATAENTRY') {
                isDataEntryOrExternal = 2
            } else if (this.EnrollmentViewModel.FORMNAME === 'NEJEPHONE') {
                isDataEntryOrExternal = 3
            } else {
                isDataEntryOrExternal = 1
            }
        } else {
            isDataEntryOrExternal = 0
        }
        if (
            this.EnrollmentViewModel !== undefined &&
            this.EnrollmentViewModel.FORMNAME !== undefined &&
            (this.EnrollmentViewModel.FORMNAME === 'EXTERNAL' ||
                this.EnrollmentViewModel.FORMNAME === 'EXTERNALSMS' ||
                this.EnrollmentViewModel.FORMNAME === 'DATAENTRY')
        ) {
            if (
                this.EnrollmentViewModel.FORMNAME === 'DATAENTRY' ||
                this.EnrollmentViewModel.FORMNAME === 'EXTERNALSMS' ||
                this.EnrollmentViewModel.FORMNAME === 'EXTERNAL'
            ) {
                this.reportFlag = true
            }
        }
        let currentDate = moment().format('YYYY-MM-DD')
        let appdate
        if (this.EnrollmentViewModel.APPDT != undefined && this._global.currentUser.insuranceCompanyName === this._global.insuranceCompanyNameNEJE) {
            appdate = moment(this.EnrollmentViewModel.APPDT).format('YYYY-MM-DD')
        } else {
            appdate = currentDate
        }
        this._enrollementGateway.getElectionFormData(planYear, isDataEntryOrExternal, appdate, this.reportFlag).subscribe((model: ElectionModel) => {
            let ElectionPeriods = model.ElectionPeriods
            this.enrollmentElectionTypes = model.EnrollmentElectionTypes

            let isAEPVisible = ElectionPeriods.findIndex((x) => x.text == 'Annual') > -1
            if (isAEPVisible) {
                this.AEPVisible.emit(true)
            }
            this.getElectionPeriods(ElectionPeriods)
            this.onEnrollmentViewModelChange()

            //if (this.EnrollmentViewModel.ELECTION !== undefined) {
            //    this.periodSelected = this.EnrollmentViewModel.ELECTION
            //    this.electionPeriodChanged(this.periodSelected)
            //    this.reasonCode = this.periodSelected
            //    if (this.EnrollmentViewModel.SEPREASONCD !== null
            //        && this.EnrollmentViewModel.SEPREASONCD !== undefined) {
            //        this.electionOptionChanged(this.EnrollmentViewModel.SEPREASONCD.toString())
            //    }
            //}
        })

        //this._enrollementGateway.getElectionPeriods(planYear, isDataEntryOrExternal)
        //    .subscribe(
        //        (model: ElectionPeriods[]) => {
        //
        //            let isAEPVisible = model.findIndex(x => x.text == "Annual") > -1
        //            if (isAEPVisible) {
        //                this.AEPVisible.emit(true)
        //            }
        //            this.getElectionPeriods(model)
        //            //this.setData()
        //
        //            this._enrollementGateway.getEnrollmentElectionTypes(insuranceCoId, planYear)
        //                .subscribe(model => {
        //                    this.enrollmentElectionTypes = model
        //
        //                    if (this.EnrollmentViewModel.ELECTION !== undefined) {
        //                        this.periodSelected = this.EnrollmentViewModel.ELECTION
        //                        this.electionPeriodChanged(this.periodSelected)
        //                        this.reasonCode = this.periodSelected
        //                        if (this.EnrollmentViewModel.SEPREASONCD !== null
        //                            && this.EnrollmentViewModel.SEPREASONCD !== undefined) {
        //                            this.electionOptionChanged(this.EnrollmentViewModel.SEPREASONCD.toString())
        //                        }
        //                    }
        //                })
        //
        //        })
    }

    private getElectionPeriods(elecPeriods: ElectionPeriods[]) {
        this.electionPeriods = elecPeriods.map(this.buildElectionOption.bind(this))
    }

    private buildElectionOption(electionPeriods: ElectionPeriods): ValidatedRadioButtonModel {
        return {
            value: electionPeriods.value,
            htmlLabel: electionPeriods.text
        }
    }
    ngAfterViewInit() {
        //this.electionPeriodChanged(this.periodSelected)
        //this.electionOptionChanged(this.reasonCode)
        //this.SetPageData()
    }

    onEnrollmentViewModelChange() {
        this.periodSelected = this.EnrollmentViewModel.ELECTION
        this.electionPeriodChanged(this.periodSelected)
        this.reasonCode = this.periodSelected
        if (this.EnrollmentViewModel.SEPREASONCD !== null && this.EnrollmentViewModel.SEPREASONCD !== undefined) {
            this.electionOptionChanged(this.EnrollmentViewModel.SEPREASONCD.toString())
        }
    }

    electionPeriodChanged(period: string) {
        if (period === '' || period === undefined) {
            return
        }

        if (this.EnrollmentViewModel.ELECTION !== period) {
            this.reasonCode = ''
            this.EnrollmentViewModel.ELECTION = ''
            this.EnrollmentViewModel.SEPREASONTEXT = ''
            this._enrollementGateway.setEnrollmentViewModel(this.EnrollmentViewModel)

            this.selectedOption = 'None'
            this.electedOptionCode = '0'
        }

        this.electionOprionsByPeriod = [] as ValidatedRadioButtonModel[]
        //this.selectedOption = 'None'
        //this.electedOptionCode = "0"

        this.isDateField = false
        this.selectedElectionTypes = this.enrollmentElectionTypes.filter((electionType) => electionType.ElectionTypeName === period)
        this.selectedElectionTypes.forEach((electionType) => {
            let newElectionOption = {} as ValidatedRadioButtonModel
            newElectionOption.value = electionType.ElectionTypeID.toString() + '|' + electionType.ElectionTypeReasonCode.toString()
            newElectionOption.htmlLabel = electionType.LongDescription
            newElectionOption.disabled = this.disabled
            this.electionOprionsByPeriod.push(newElectionOption)
        })

        this.periodSelectdChanged.emit(period)
        this.selElectionPeriod.sendData(period)
        this.selElectionPeriod.electionPeriodChanged(period)
        if (period !== null && period.toString().toLowerCase() !== 'special') {
            this.sepDate = null
            this.sepDateChanged(this.sepDate)
        }
    }

    electionOptionChanged(option: string) {
        if (option === '-1' || option === undefined) {
            return
        }
        //  this.electedOptionCode = option

        if (option.split('|').length > 1) {
            let selOption = option.split('|')[1]
            this.electedOptionCode = selOption
        } else {
            if (this.EnrollmentViewModel === undefined) {
                this.EnrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
            }
            let id = this.EnrollmentViewModel.ELECTIONTYPEID
            if (id === undefined) {
                let selElectionTypes = this.selectedElectionTypes.filter((electionType) => electionType.ElectionTypeID === parseInt(option))
                if (selElectionTypes !== undefined && selElectionTypes.length > 0) {
                    let reasonCode = selElectionTypes[0].ElectionTypeReasonCode
                    option = option + '|' + reasonCode
                    let selOption = option.split('|')[1]
                    this.electedOptionCode = selOption
                } else {
                    let selElectionTypes = this.selectedElectionTypes.filter(
                        (electionType) => electionType.ElectionTypeReasonCode === parseInt(option)
                    )
                    id = selElectionTypes[0].ElectionTypeID.toString()
                    option = id + '|' + option
                    let selOption = option.split('|')[1]
                    this.electedOptionCode = selOption
                }
            } else {
                option = id.toString() + '|' + option
                let selOption = option.split('|')[1]
                this.electedOptionCode = selOption
            }

            // }
        }

        //let electionTypes = this.selectedElectionTypes.filter(
        //    electionType => electionType.ElectionTypeReasonCode === parseInt(option))

        let electionTypes = this.selectedElectionTypes.filter((electionType) => electionType.ElectionTypeID === parseInt(option.split('|')[0]))

        if (electionTypes && electionTypes.length > 0) {
            this.isDateField = electionTypes[0].IsDateField

            if (
                electionTypes[0].ElectionTypeID.toString() === this.EnrollmentViewModel.ELECTIONTYPEID ||
                electionTypes[0].ElectionTypeID === this.EnrollmentViewModel.SEPREASONCD
            )
                this.sepDate = this.EnrollmentViewModel.SEPEFFDT
            else this.sepDate = null
            //this.selectedOption = this.electionOprionsByPeriod.filter(
            //    electionOption => electionOption.value === option.toString())[0].htmlLabel
        }

        if (this.EnrollmentViewModel.SEPEFFDT !== undefined && this.EnrollmentViewModel.SEPEFFDT !== null)
            this.sepDate = this.EnrollmentViewModel.SEPEFFDT

        let id = option.split('|')[0].toString()
        let filteredOptions = this.electionOprionsByPeriod.filter((electionOption) => electionOption.value === option)
        if (filteredOptions.length > 0) {
            this.selectedOption = filteredOptions[0].htmlLabel
        } else {
            this.selectedOption = ''
            this.electedOptionCode = ''
            id = ''
        }

        let electionPeriodsSel = {
            value: this.electedOptionCode,
            text: this.selectedOption,
            id: id
        }
        this.reasonCode = option
        this.reasonCodeChanged.emit(electionPeriodsSel)
        this.hasDateField.emit(this.isDateField)
    }
    sepDateChanged(date: any) {
        this.sepDateChange.emit(date)
    }
}
